// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_y3z","cls2":"Header-cls2__uj Header-cls1_y3z"};